import { render, staticRenderFns } from "./CloHeader.vue?vue&type=template&id=12eccf5e&"
import script from "./CloHeader.vue?vue&type=script&lang=js&"
export * from "./CloHeader.vue?vue&type=script&lang=js&"
import style0 from "./CloHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports